import React from 'react';
import './MaintenencePage.scss';
const BANNER_TEXT = 'We’re enhancing product images for a better browsing experience';
const showIcon = false;

const MaintenanceBanner: React.FC = () => {
	return (
		<div className='maintenance-banner' role='status' aria-live='polite'>
			{showIcon && (
				<span className='maintenance-banner__icon' aria-hidden='true'>
					<svg viewBox='0 0 24 24' width='16' height='16' fill='currentColor'>
						<path d='M12 2 1 21h22L12 2zm0 4.8L19.5 19h-15L12 6.8zM11 10v4h2v-4h-2zm0 5v2h2v-2h-2z' />
					</svg>
				</span>
			)}

			<span className='maintenance-banner__text'>{BANNER_TEXT}</span>
		</div>
	);
};

export default MaintenanceBanner;
